module.exports = __webpack_public_path__ + "static/media/delete.4c837169.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/delete.svg
// module id = 129
// module chunks = 0